<template>
  <div class="w-full mt-5 flex flex-col border-0 p-0">
    <label
      :for="id"
      v-if="label"
      class="mb-2 text-xs md:text-xs text-left text-gray-500 text-opacity-80"
      :class="{ 'text-red-500': invalid }"
      ><b>{{ label }}</b
      ><span v-if="required" class="text-red-500">*</span></label
    >
    <p v-if="sublabel" class="text-xs text-gray-400 text-left mb-2">
      {{ sublabel }}
    </p>

    <a-time-picker
      :id="id"
      size="large"
      :disabled="disabled"
      :placeholder="placeholder ? placeholder : 'Seleccionar hora'"
      :format="format ? format : 'HH:mm'"
      :value="timeValue"
      :allowClear="allowClear"
      :disabled-hours="disabledHours"
      :disabled-minutes="disabledMinutes"
      :class="{ 'border-red-500': invalid }"
      class="w-full"
      @change="handleChange"
    />

    <p
      v-if="invalid"
      class="mt-2 text-left text-xs text-red-500"
      aria-live="polite"
    >
      {{ feedback || 'Este campo es obligatorio' }}
    </p>
  </div>
</template>

<script>
import moment from "moment";

export default {
  props: {
    id: String,
    label: String,
    sublabel: String,
    required: Boolean,
    value: [String, Object],
    placeholder: String,
    disabled: Boolean,
    format: {
      type: String,
      default: "HH:mm",
    },
    allowClear: {
      type: Boolean,
      default: true,
    },
    disabledHours: {
      type: Function,
      default: () => [],
    },
    disabledMinutes: {
      type: Function,
      default: () => [],
    },
    feedback: String,
  },
  data() {
    return {
      invalid: false,
    };
  },
  computed: {
    timeValue() {
      if (!this.value) return null;
      return typeof this.value === "string"
        ? moment(this.value, this.format)
        : this.value;
    },
  },
  methods: {
    handleChange(time, timeString) {
      this.invalid = false;
      this.$emit("input", timeString);
      this.$emit("change", timeString);
    },
    setInvalid(invalid) {
      if (this.required) {
        this.invalid = invalid;
      }
    },
  },
  watch: {
    value(val) {
      if (!val && this.required) {
        this.invalid = true;
      } else {
        this.invalid = false;
      }
    },
  },
};
</script>

<style scoped>
/* Estilos similares a BaseSelect para mantener consistencia */
.ant-time-picker {
  width: 100%;
}
</style>

<style>
/* Ocultar opciones deshabilitadas en el panel del TimePicker */
.ant-time-picker-panel-select-option-disabled {
  display: none !important;
}
</style>
